import request from '@/utils/request'

// 获取成员列表
export function getMemberList(data) {
  return request({
    url: '/sys/member/list',
    method: 'post',
    data
  })
}

export function memberExport(data) {
  return request({
    url: '/sys/member/exportUser',
    method: 'post',
    loading: true,
    responseType: 'blob',
    data
  })
}

// 设置状态
export function setStatus(data) {
  return request({
    url: '/sys/member/updateByStatus',
    method: 'post',
    data
  })
}

// 修改组别
export function setGroup(data) {
  return request({
    url: '/sys/member/updateSubgroup',
    method: 'post',
    data
  })
}

// 运动队下拉列表
export function teamList() {
  return request({
    url: `/sys/team/sportTeamList`,
    method: 'post',
  })
}

// 运动组列表
export function groupList(data) {
  return request({
    url: `/sys/group/sportGroupList`,
    method: 'get',
    params: data
  })
}

// 删除用户
export function memberDel(data) {
  return request({
    url: `/sys/member/del`,
    method: 'post',
    data
  })
}

// 获取成员详情
export function memberInfo(id) {
  return request({
    url: `/sys/member/info/${id}`,
    method: 'get',
  })
}

// 修改成员信息
export function editUser(data) {
  return request({
    url: `/sys/member/edit`,
    method: 'post',
    data
  })
}

// 获取操作记录
export function operateRecord(data) {
  return request({
    url: `/sys/operatingRecord/list`,
    method: 'post',
    data
  })
}

// 运动视频
export function getSportVideo(data) {
  return request({
    url: `/api/drillVideo/findSysDrillVideo`,
    method: 'post',
    data
  })
}

// 获取云点播视频
export function getPlayUrls(id) {
  return request({
    url: `/api/file/getPlayUrl?videoId=${id}`,
    method: 'get',
  })
}

// 分析结果
export function getReportList(data) {
  return request({
    url: `/sys/sports/pcVideoAnalysisPageList`,
    method: 'post',
    data
  })
}

// 运动队列表
export function getTeamList(data) {
  return request({
    url: `/sys/team/pageList`,
    method: 'post',
    data
  })
}

// 运动队启用
export function teamSwitch(data) {
  return request({
    url: `/sys/team/updateByStatus`,
    method: 'post',
    data
  })
}

// 运动队删除
export function teamDel(data) {
  return request({
    url: `/sys/team/del`,
    method: 'post',
    data
  })
}
// 新增运动队
export function teamAdd(data) {
  return request({
    url: `/sys/team/add`,
    method: 'post',
    data
  })
}

// 编辑运动队
export function teamEdit(data) {
  return request({
    url: `/sys/team/edit`,
    method: 'post',
    data
  })
}

// 运动组列表
export function getGroupList(data) {
  return request({
    url: `/sys/group/pageList`,
    method: 'post',
    data
  })
}

// 新增运动组
export function groupAdd(data) {
  return request({
    url: `/sys/group/add`,
    method: 'post',
    data
  })
}

// 编辑运动组
export function groupEdit(data) {
  return request({
    url: `/sys/group/edit`,
    method: 'post',
    data
  })
}
// 运动队删除
export function groupDel(data) {
  return request({
    url: `/sys/group/del`,
    method: 'post',
    data
  })
}
// 运动队启用
export function groupSwitch(data) {
  return request({
    url: `/sys/group/updateByStatus`,
    method: 'post',
    data
  })
}

// 成员审批
export function memberAudit(data) {
  return request({
    url: `/sys/member/approvalUser`,
    method: 'post',
    data
  })
}

// 导入成员
export function memberImportUser(data) {
  return request({
    url: `/sys/member/importUser`,
    method: 'post',
    data
  })
}

export function memberTree(data) {
  return request({
    url: `/sys/member/userGroupTree`,
    method: 'post',
    data
  })
}

// 成员下拉列表
export function memberAll(data) {
  return request({
    url: `/sys/member/listAll`,
    method: 'post',
    data
  })
}

// 新增运动队管理员
export function adminAdd(data) {
  return request({
    url: `/sys/member/addGroupRole`,
    method: 'post',
    data
  })
}

// 运动队管理员列表
export function adminList(data) {
  return request({
    url: `/sys/member/findGroupRole`,
    method: 'get',
    params: data
  })
}

// 编辑运动队管理员
export function adminEdit(data) {
  return request({
    url: `/sys/member/updateGroupRole`,
    method: 'post',
    data
  })
}
// 运动队管理员删除
export function adminDel(id) {
  return request({
    url: `/sys/member/delGroupRole?userId=${id}`,
    method: 'get',
  })
}

// 机构列表
export function orgList(data) {
  return request({
    url: `/sys/info/organizationFindByType`,
    method: 'get',
    params: data
  })
}